import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import { CostBreakdownAssemblyDetailPage } from '@/areas/cost-breakdown/CostBreakdown/SourcingCostBreakdown/CostBreakdownAssemblyDetailPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute(
    '/_authenticated/projects/$projectId/sourcing/scenarios/$sourcingScenarioId/_sidebar/cost-breakdown/assembly/$assemblyId/demand/$demandId',
)({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'project',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ parentPath: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    const parentPath = Route.useSearch({ select: (search) => search.parentPath });
    return <CostBreakdownAssemblyDetailPage {...pathParams} parentPath={parentPath} />;
}
